// src/context/SelectedMediaContext.jsx
import React, { createContext, useContext, useState } from 'react';

const SelectedMediaContext = createContext(null);

export function SelectedMediaProvider({ children }) {
  const [selectedMedia, setSelectedMedia] = useState(null);

  return (
    <SelectedMediaContext.Provider value={{ selectedMedia, setSelectedMedia }}>
      {children}
    </SelectedMediaContext.Provider>
  );
}

export function useSelectedMedia() {
  const context = useContext(SelectedMediaContext);
  if (!context) {
    throw new Error('useSelectedMedia must be used within SelectedMediaProvider');
  }
  return context;
}
